// src/dashboard/DashboardLayout.jsx

import { Link, Outlet, NavLink } from "react-router-dom";
import { useState } from "react";
import DashboardNavbar from "./DashboardNavbar";

function DashboardLayout() {
  const [sidebarOpen, setSidebarOpen] = useState(true);

  return (
    <div className="flex min-h-screen">
      {/* Sidebar */}
      <div
        className={`transition-all duration-300 bg-orange-500 text-white  shadow-md ${
          sidebarOpen ? "w-64" : "w-16"
        } overflow-hidden`}
      >
        <div className="flex justify-between items-center p-4 border-b">
          <Link
            to="/"
            className={`text-white font-semibold px-3 py-2 rounded hover:bg-orange-600 transition duration-300 ${
              sidebarOpen ? "text-base" : "text-xl"
            }`}
          >
            {sidebarOpen ? "🏠 मुख्यपृष्ठावर जा" : "🏠"}
          </Link>
          <button
            onClick={() => setSidebarOpen(!sidebarOpen)}
            className="text-gray-600"
          >
            {sidebarOpen ? "⬅️" : "➡️"}
          </button>
        </div>
       <nav className="mt-4 space-y-2">
  <NavLink
    to="/dashboard/yatra-list"
    className={({ isActive }) =>
      `block px-4 py-2 rounded transition duration-300 ${
        isActive ? "bg-orange-700 font-bold" : "hover:bg-orange-600"
      }`
    }
  >
    {sidebarOpen ? "यात्रा सूची" : "📜"}
  </NavLink>

  <NavLink
    to="/dashboard/yatra-past-list"
    className={({ isActive }) =>
      `block px-4 py-2 rounded transition duration-300 ${
        isActive ? "bg-orange-700 font-bold" : "hover:bg-orange-600"
      }`
    }
  >
    {sidebarOpen ? "मागील यात्रा" : "🕉️"}
  </NavLink>
</nav>

      </div>

      {/* Main Content */}
      <div className="flex-1 flex flex-col">
        <DashboardNavbar />
        <main className="p-4 bg-gray-100 flex-grow">
          <Outlet /> {/* This renders nested routes like YatraList */}
        </main>
      </div>
    </div>
  );
}

export default DashboardLayout;
